module.exports = __webpack_public_path__ + "img/20200613_093216.493442a5.jpg";